import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-text-input',
  imports: [
    FormsModule,
    NgOptimizedImage
],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.css'
})
export class TextInputComponent {
  @Input()
  value: string | number | null = null;

  @Output()
  valueChange = new EventEmitter<string>();

  @Input()
  placeholder: string | null = null;

  @Input()
  showError: boolean = false;

  @Input()
  type: string = "text";

  @Input()
  required: boolean = false;

  @Input()
  errorMessage: string = '';

  @Input()
  useErrorHandlingV2: boolean = false;

  hasError() {
    if (this.useErrorHandlingV2) {
      return this.hasErrorV2()
    }
    return (this.showError && this.required) ? !this.value : false
  }

  hasErrorV2() {
    return this.showError
  }
}
